import { fonts } from '@/theme/fonts';
import styled from 'styled-components';

interface CommonTitleProps {
  title: string;
  count?: number;
  disabled?: boolean;
}

const CommonTitle = ({ title, count, disabled = false }: CommonTitleProps) => {
  return (
    <Container data-disabled={disabled}>
      <TitleWrap>
        <Title>{title}</Title>
        {count !== undefined && <Count>({count})</Count>}
      </TitleWrap>
    </Container>
  );
};

export default CommonTitle;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #111827;

  &[data-disabled='true'] {
    color: #9ca3af;
  }
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Title = styled.div`
  font-family: ${fonts.family.inter};
  font-weight: ${fonts.weight.bold};
  font-size: 24px;
  line-height: 32px;
`;

const Count = styled.div`
  font-size: 16px;
  font-weight: ${fonts.weight.medium};
  color: #6b7280;
`;
